import { z } from "zod";
import { format, isAfter, parseISO } from "date-fns";

const now = new Date();
const dateStart = format(now, "yyyy-MM-dd");
const dateEnd = format(now, "yyyy-MM-dd");

export const defaultValues = {
	id_promocao: 0,
	id_empresa: 0,
	descricao: "",
	inicio: dateStart,
	fim: dateEnd,
	status: true,
	cod_cupom: "",
	todos_produtos: true,
	valor_minimo: 0,
	perc_desconto: 0,
	valor_desconto: 0,
};

export const schema = z
	.object({
		id_promocao: z.union([z.string(), z.number()]).transform((val) => Number(val)),
		id_empresa: z.union([z.string(), z.number()]).transform((val) => Number(val)),
		descricao: z.string().trim().min(1, "Descrição é obrigatória").max(100),
		inicio: z.string().min(1, "Data de início é obrigatória"),
		fim: z.string().min(1, "Data de término é obrigatória"),
		status: z.boolean(),
		cod_cupom: z
			.string()
			.trim()
			.min(1, "Código do cupom é obrigatório")
			.refine((val) => !/\s/.test(val), "O código não pode conter espaços")
			.transform((val) => val.toUpperCase()),
		todos_produtos: z.boolean(),
		valor_minimo: z.coerce.number().min(0),
		perc_desconto: z.coerce.number().min(0).max(100).optional(),
		valor_desconto: z.coerce.number().min(0).optional(),
		tipo_desconto: z.string().optional(),
	})
	.refine(
		(data) => {
			try {
				const start = parseISO(data.inicio);
				const end = parseISO(data.fim);
				// Valida se fim >= inicio
				return isAfter(end, start) || format(start, "yyyy-MM-dd") === format(end, "yyyy-MM-dd");
			} catch (e) {
				return false;
			}
		},
		{
			message: "A data de término deve ser igual ou maior que a data de início",
			path: ["fim"],
		}
	)
	.refine(
		(data) => {
			if (data.tipo_desconto === "PERCENTUAL") {
				return Number(data.perc_desconto) > 0;
			} else {
				return Number(data.valor_desconto) > 0;
			}
		},
		(data) => ({
			message: "Informe um valor de desconto maior que zero",
			path: [data.tipo_desconto === "PERCENTUAL" ? "perc_desconto" : "valor_desconto"],
		})
	);
